export default function ({ $gtm, route }) {
  if (['light-farms-1', 'walsh-1'].includes(route.params.slug))
    $gtm.init('GTM-K8SB73C')
}
